module.exports = __webpack_public_path__ + "img/IMG_1149_Mockup.41873e2a.jpg";